import { render } from "./particles.vue?vue&type=template&id=0ff6792c"
const script = {}

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__